var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChevronRight16 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 16,
  fill: "none",
  viewBox: "0 0 12 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M4.2197 3.4697a.75.75 0 0 1 1.0606 0l4 4a.75.75 0 0 1 0 1.0606l-4 4a.75.75 0 0 1-1.0606-1.0606L7.6893 8 4.2197 4.5303a.75.75 0 0 1 0-1.0606Z",
  clipRule: "evenodd"
})));
export { SvgChevronRight16 as ReactComponent };